module.exports = __webpack_public_path__ + "static/81365f1184e24029303e436309b6f4361581451a368eca320b56f6f42e9ab27f-abd1caa7cceb1621688f360564410bde.png";